(() => {
  const setupCarousel = (carousel, slideSelector, dotSelector, pauseOnHover) => {
    if (!carousel || carousel.dataset.carouselReady === 'true') return;
    const slides = [...carousel.querySelectorAll(slideSelector)];
    const dots = [...carousel.querySelectorAll(dotSelector)];
    if (slides.length < 2) return;

    carousel.dataset.carouselReady = 'true';
    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('active')));
    let timer;
    const interval = Number(carousel.dataset.interval) || 6000;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('active', slideIndex === current));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === current));
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(current + 1), interval);
      }
    };

    carousel.querySelector('[data-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
    carousel.querySelector('[data-next]')?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slide)); start(); }));
    if (pauseOnHover) {
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
    }
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(current);
    start();
  };

  const initializeTheme = (root = document) => {
    root.querySelectorAll('[data-hero-carousel]').forEach((carousel) => setupCarousel(carousel, '.hero-slide', '.hero-carousel-dot', false));
    root.querySelectorAll('[data-lookbook-carousel]').forEach((carousel) => setupCarousel(carousel, '.lookbook-carousel-slide', '.lookbook-carousel-dot', true));
  };

  document.addEventListener('DOMContentLoaded', () => initializeTheme());
  document.addEventListener('shopify:section:load', (event) => initializeTheme(event.target));
})();
